<div class="strip"></div>
